import Logo from "@/app/(components)/generics/Logo/Logo";
import PulseCircle from "@/app/(components)/generics/PulseCircle/PulseCircle";
import { FLOW_LIST_TAG_PAIRS } from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";
import ConceptFlowTagPair from "./ConceptFlowTagPair";

export default function ConceptFlowMemory() {
  return (
    <div className={styles.memory} aria-hidden="true">
      <span className={styles.hub}>
        <PulseCircle isQuiet>
          <Logo min light ignoreBrand nonInteractive className={styles.hubLogo} />
        </PulseCircle>
      </span>
      <span className={styles.listTags}>
        {FLOW_LIST_TAG_PAIRS.map((pair) => (
          <ConceptFlowTagPair pair={pair} key={pair.id} />
        ))}
      </span>
    </div>
  );
}
